<template>
  <div class="container page">
    <van-nav-bar :title="$t('withdraw.with_center')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
      <template #right>
        <span class="nav-right" @click="$router.push({path:'/WithdrawRecord'})">{{$t("withdraw.with_record")}}</span>
      </template>
    </van-nav-bar>
    <div class="main">

      <!-- 余额展示 -->
      <div class="balance-card">
        <div class="balance-title">{{$t("my.balance")}}</div>
        <div class="balance-row">
          <span class="balance-num">{{ this.userInfo.money || 0 }}</span>
          <span class="balance-unit">{{$t("reservation.unit")}}</span>
          <span class="balance-all-btn" @click="allMoeny()">{{$t("index.all")}}</span>
        </div>
      </div>

      <!-- 银行卡选择区 -->
      <div class="bank-section">
        <div class="section-header">
          <span class="section-title">{{$t('withdraw.select_bank')}}</span>
          <span class="section-num">{{$t('setting.bound_cards', {count: bankInfo.count, max: bankInfo.max_count})}}</span>
        </div>

        <!-- 未绑卡 空状态 -->
        <div v-if="!bankInfo.is_bank || !bankInfo.list || bankInfo.list.length === 0" class="empty-bank">
          <div class="empty-bank-icon">💳</div>
          <div class="empty-bank-text">{{$t('withdraw.no_bank_card')}}</div>
          <div class="empty-bank-sub">{{$t('withdraw.add_bank_first')}}</div>
          <van-button class="empty-bank-btn" type="default" @click="goBindCard()">{{$t('setting.add_bank')}}</van-button>
        </div>

        <!-- 已绑卡列表（单选） -->
        <div v-else class="bank-list">
          <div
            v-for="(item, idx) in bankInfo.list"
            :key="item.id"
            class="bank-card"
            :class="{ 'bank-card-active': selectedBindId === item.id }"
            @click="selectBank(item)">
            <div class="bank-card-left">
              <div class="bank-ic" :style="bankColorStyle(idx)"></div>
            </div>
            <div class="bank-card-mid">
              <div class="bank-name-line">
                <span class="bank-name">{{ item.bankinfo || $t('withdraw.bank_card') }}</span>
                <span class="bank-default-tag" v-if="idx === 0 && bankInfo.list.length > 1">{{$t('common.default')}}</span>
              </div>
              <div class="bank-user-line">
                <span class="bank-user">{{ item.username || '--' }}</span>
                <span class="bank-phone">{{ maskPhone(item.mobile) }}</span>
              </div>
              <div class="bank-card-line">{{ maskBankId(item.bankid) }}</div>
            </div>
            <div class="bank-card-right">
              <span class="radio-circle" :class="{ 'radio-circle-on': selectedBindId === item.id }">
                <span class="radio-dot"></span>
              </span>
            </div>
          </div>
        </div>

        <!-- 未满 5 张：下方显示添加新卡 -->
        <div v-if="bankInfo.count < bankInfo.max_count" class="add-bank-wrap">
          <div class="add-bank-card" @click="goBindCard()">
            <span class="add-bank-plus">＋</span>
            <span class="add-bank-text">{{$t('withdraw.add_new_bank', {n: bankInfo.max_count - bankInfo.count})}}</span>
          </div>
        </div>
      </div>

      <!-- 提现金额输入 -->
      <div class="withdraw-section">
        <div class="section-header">
          <span class="section-title">{{$t("withdraw.with_money")}} ({{$t("reservation.unit")}})</span>
          <span class="section-info" v-if="withdrawRole.max">
            {{$t('withdraw.single_range', {min: withdrawRole.min, max: withdrawRole.max})}}
          </span>
        </div>
        <div class="money-input-wrap">
          <van-field v-model="withdraw_money" class="money-input" type="number" :placeholder="$t('withdraw.with_money_place')" />
          <span class="money-all-btn" @click="allMoeny()">{{$t("index.all")}}</span>
        </div>
        <div class="information">
          <div class="description">
            <van-popover v-model="showPopover" trigger="click">
              <div class="popover-body" style="padding: 10px;">
                <p>1.{{$t("withdraw.single_limit")}}{{$t("withdraw.low")}}{{this.withdrawRole.min}}{{$t("withdraw.heigh")}}{{this.withdrawRole.max}}{{$t("reservation.unit")}}</p>
                <p>2.{{$t("withdraw.with_num")}}{{this.withdrawRole.num}}{{$t("withdraw.number")}}</p>
                <p>3.{{$t("withdraw.with_tip")}}</p>
              </div>
              <template #reference @click="withdrawInfo()">
                <van-icon name="info-o" />
                {{$t("withdraw.limit_desc")}}
              </template>
            </van-popover>
          </div>
        </div>
      </div>

      <!-- 立即提现按钮 -->
      <van-button class="withdraw_btn" type="default" @click="doWithdraw()">
        {{$t("withdraw.immediately_withdraw")}}
      </van-button>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showPopover: false,
      withdraw_money:"",
      userInfo:{},
      withdrawRole:{
        min:0, max:0, num:0
      },
      bankInfo:{
        is_bank:false,
        count:0,
        max_count:5,
        default_bind_id:0,
        list:[]
      },
      selectedBindId: 0
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    // 手机号脱敏 138****1234
    maskPhone(tel){
      if(!tel) return '--';
      const s = String(tel);
      if(s.length < 7) return s;
      return s.substring(0,3) + '****' + s.substring(s.length - 4);
    },
    // 卡号脱敏 后4位前加*
    maskBankId(id){
      if(!id) return '**** **** **** ****';
      const s = String(id).replace(/\s/g,'');
      if(s.length <= 4) return s;
      const last4 = s.substring(s.length - 4);
      return '**** **** **** ' + last4;
    },
    bankColorStyle(idx){
      const list = [
        'linear-gradient(135deg,#667eea,#764ba2)',
        'linear-gradient(135deg,#f093fb,#f5576c)',
        'linear-gradient(135deg,#4facfe,#00f2fe)',
        'linear-gradient(135deg,#43e97b,#38f9d7)',
        'linear-gradient(135deg,#fa709a,#fee140)'
      ];
      const bg = list[idx % list.length];
      return 'background-image:' + bg + ';';
    },
    selectBank(item){
      this.selectedBindId = item.id;
    },
    goBindCard(){
      this.$router.push({
        name:'BindCard',
        query:{ from:'withdraw' }
      });
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.name = res.data.name;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserBankInfo(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res=>{
        if(res.code === 200){
          const d = res.data || {};
          this.bankInfo = {
            is_bank: !!d.is_bank,
            count: d.count || 0,
            max_count: d.max_count || 5,
            default_bind_id: d.default_bind_id || 0,
            list: Array.isArray(d.list) ? d.list : []
          };
          // 默认选中第一张
          if(!this.selectedBindId){
            this.selectedBindId = this.bankInfo.default_bind_id;
          }
          if(!this.selectedBindId && this.bankInfo.list && this.bankInfo.list.length > 0){
            this.selectedBindId = this.bankInfo.list[0].id;
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserWithdrawRole(){
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_role'
      }).then(res=>{
        if(res.code === 200){
          this.withdrawRole = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    allMoeny(){
      this.withdraw_money = this.userInfo.money;
    },
    doWithdraw(){
      if(!this.bankInfo.is_bank || this.bankInfo.list.length === 0){
        this.$toast(this.$t('withdraw.bind_bank_first'));
        return false;
      }
      if(!this.selectedBindId){
        this.$toast(this.$t('withdraw.select_withdraw_bank'));
        return false;
      }
      if(!this.withdraw_money || Number(this.withdraw_money) <= 0){
        this.$toast(this.$t("setting.correct_money"));
        return false;
      }
      this.$http({
        method: 'post',
        data:{
          money:this.withdraw_money,
          bank_bind_id: this.selectedBindId
        },
        url: 'user_set_withdraw'
      }).then(res=>{
        if(res.code === 200){
          this.$toast(res.msg);
          this.withdraw_money = "";
          this.getUserInfo();
          this.getUserWithdrawRole();
          setTimeout(()=>{
            this.$router.push({path:'/WithdrawRecord'});
          }, 800);
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    withdrawInfo(){
      this.showPopover = true;
    }
  },
  activated(){
    // 从绑卡页返回时刷新列表（keep-alive 场景）
    this.getUserBankInfo();
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
      this.getUserBankInfo();
      this.getUserWithdrawRole();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.van-cell {
  font-size: 32px;
  line-height: 80px;
}
.container .main{
  display: flex;
  flex-direction: column;
  background-color: #f2f2f5;
  min-height: calc(100vh - 50px);
  padding-bottom: 60px;
  box-sizing: border-box;
  position: relative;
}

/* 顶部余额卡 */
.balance-card{
  margin: 20px;
  padding: 24px;
  border-radius: 16px;
  background: linear-gradient(135deg,#988fba 0%,#f487e0 100%);
  color: #fff;
  box-shadow: 0 8px 24px rgba(148,116,212,0.2);
}
.balance-title{
  font-size: 26px;
  opacity: 0.9;
}
.balance-row{
  margin-top: 10px;
  display: flex;
  align-items: center;
}
.balance-num{
  font-size: 64px;
  font-weight: bolder;
  line-height: 1.1;
}
.balance-unit{
  margin-left: 12px;
  font-size: 28px;
  opacity: 0.9;
}
.balance-all-btn{
  margin-left: auto;
  padding: 8px 24px;
  font-size: 26px;
  border-radius: 999px;
  background: rgba(255,255,255,0.2);
  color: #fff;
}
.balance-all-btn:active{
  transform: scale(0.96);
  opacity: 0.85;
}

/* 通用区块头 */
.section-header{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px 16px;
}
.section-title{
  font-size: 30px;
  font-weight: 600;
  color: #222;
}
.section-num,
.section-info{
  font-size: 24px;
  color: #888;
}

/* 银行卡区块 */
.bank-section{
  background: #fff;
  padding: 24px 0 16px;
}

/* 空状态 */
.empty-bank{
  text-align: center;
  padding: 30px 20px 10px;
}
.empty-bank-icon{
  font-size: 90px;
  line-height: 1;
  opacity: 0.55;
}
.empty-bank-text{
  margin-top: 12px;
  font-size: 32px;
  font-weight: 600;
  color: #222;
}
.empty-bank-sub{
  margin-top: 8px;
  font-size: 26px;
  color: #999;
}
.empty-bank-btn{
  margin: 28px auto 0;
  height: 72px;
  line-height: 72px;
  padding: 0 60px;
  font-size: 28px;
  color: #fff;
  border: none;
  border-radius: 999px;
  background: linear-gradient(90deg,#988fba,#f487e0);
}

/* 银行卡列表（单选） */
.bank-list{
  padding: 0 20px;
}
.bank-card{
  display: flex;
  align-items: center;
  padding: 18px 20px;
  margin-bottom: 16px;
  border-radius: 14px;
  background: #fafafa;
  border: 2px solid transparent;
  transition: all 0.2s ease;
}
.bank-card-active{
  background: #fff;
  border-color: #988fba;
  box-shadow: 0 6px 18px rgba(152,143,186,0.12);
}
.bank-card-left{
  flex-shrink: 0;
  width: 92px;
  height: 92px;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.bank-ic{
  width: 100%;
  height: 100%;
  border-radius: 12px;
  position: relative;
}
.bank-ic::before{
  content: '';
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at 20% 20%, rgba(255,255,255,0.28), transparent 40%),
    radial-gradient(circle at 80% 80%, rgba(255,255,255,0.2), transparent 45%);
}
.bank-card-mid{
  flex: 1;
  margin-left: 20px;
  min-width: 0;
}
.bank-name-line{
  display: flex;
  align-items: center;
  gap: 10px;
}
.bank-name{
  font-size: 30px;
  font-weight: 600;
  color: #222;
}
.bank-default-tag{
  padding: 2px 10px;
  font-size: 20px;
  color: #c9a86c;
  border-radius: 4px;
  background: rgba(201,168,108,0.1);
}
.bank-user-line{
  margin-top: 6px;
  display: flex;
  gap: 18px;
  font-size: 24px;
  color: #666;
}
.bank-card-line{
  margin-top: 8px;
  font-size: 30px;
  font-family: Menlo,Consolas,monospace;
  color: #222;
  letter-spacing: 2px;
}
.bank-card-right{
  flex-shrink: 0;
  margin-left: 12px;
}
.radio-circle{
  display: inline-block;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid #dcdcdc;
  position: relative;
  background: #fff;
}
.radio-circle-on{
  border-color: #988fba;
}
.radio-dot{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%) scale(0);
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: linear-gradient(135deg,#988fba,#f487e0);
  transition: transform 0.2s ease;
}
.radio-circle-on .radio-dot{
  transform: translate(-50%,-50%) scale(1);
}

/* 加新卡 */
.add-bank-wrap{
  padding: 12px 20px 4px;
}
.add-bank-card{
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 20px;
  border-radius: 14px;
  border: 2px dashed #c9b4df;
  color: #7b5fb4;
  background: rgba(152,143,186,0.04);
}
.add-bank-card:active{
  background: rgba(152,143,186,0.08);
}
.add-bank-plus{
  font-size: 36px;
  font-weight: 300;
  line-height: 1;
}
.add-bank-text{
  font-size: 28px;
}

/* 提现金额区 */
.withdraw-section{
  margin-top: 20px;
  background: #fff;
  padding: 24px 0 10px;
}
.money-input-wrap{
  margin: 0 20px;
  padding: 18px 16px;
  border-radius: 14px;
  background: #fafafa;
  display: flex;
  align-items: center;
  gap: 16px;
}
.money-input{
  flex: 1;
  min-width: 0;
}
.money-input::v-deep .van-field__control{
  font-size: 54px;
  font-weight: 700;
  color: #d10404;
}
.money-all-btn{
  flex-shrink: 0;
  padding: 14px 28px;
  font-size: 26px;
  font-weight: 600;
  color: #fff;
  border-radius: 999px;
  background: linear-gradient(90deg,#988fba,#f487e0);
  box-shadow: 0 4px 12px rgba(152,143,186,0.25);
}
.money-all-btn:active{
  transform: scale(0.96);
  opacity: 0.85;
}
.information{
  padding: 0 20px 20px;
}
.information .description {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 10px 0 0;
  font-size: 24px;
  color: #888;
}

/* 立即提现按钮 */
.withdraw_btn {
  margin: 30px 30px 0;
  height: 88px;
  line-height: 88px;
  border-radius: 999px;
  color: #fff;
  font-size: 32px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(90deg,#988fba,#f487e0);
  box-shadow: 0 10px 24px rgba(244,135,224,0.25);
}
.withdraw_btn:active{
  transform: scale(0.98);
  opacity: 0.9;
}
.nav-right{
  font-size: 26px;
  color: #fff;
}
</style>
